export default __webpack_public_path__ + "static/media/map-element-2.df4e0569.svg";